import { DataPackSyncQueue } from './../../../../models/dataPackSyncQueue.model';
import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../modalLoading/content.component';

import * as _ from 'lodash';
import { ConfigureSyncModalComponent } from '../configure/content.component';
import { VivoSyncService } from 'app/services/vivo.sync.service';
import { DataPackSyncControl } from 'app/models/dataPackSyncControl.model';
import { interval } from 'rxjs/observable/interval';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

/**
 * @version $Id$
 */
@Component({
  selector: 'syncList',
  templateUrl: './content.template.html'
})
export class SyncListComponent implements OnInit, OnDestroy, AfterViewInit {

  private static readonly GROUPS_FETCH_SIZE: number = 100;
  private static readonly LINES_FETCH_SIZE: number = 20;
  private static readonly FILTER_SYNC_LINES = 'all_sync_lines';

  public filter: string = SyncListComponent.FILTER_SYNC_LINES;
  public groupsFetchSize: number = SyncListComponent.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = SyncListComponent.LINES_FETCH_SIZE;

  public groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public selectedLineAcount: Array<DataPackLine> = new Array<DataPackLine>();
  public displayShowMoreLinesButton: Map<string, boolean> = new Map<string, boolean>();
  public selectedGroup: DataPackGroup;
  public filteredGroups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public control: DataPackSyncControl = new DataPackSyncControl();
  public filterValue: string = '';
  public displayShowMoreGroupsButton: boolean = false;
  public groupSortingCriteria: string;
  public groupSortingAsc: boolean = true;
  public lineSortingCriteria: string;
  public lineSortingAsc: boolean = true;
  public hideLinesGroup: boolean = false;
  public hideButton: boolean = true;
  public page: number;
  public pageGroup: number;
  public filtered: boolean = false;
  public totalGroups: number;
  public checkAll: boolean;
  private reloadInterval: Subscription;
  private timer: any;

  public linesWithSuccess: Array<DataPackSyncQueue> = new Array<DataPackSyncQueue>();
  public linesWithError: Array<DataPackSyncQueue> = new Array<DataPackSyncQueue>();

  public isProcessing = false;

  constructor(private modal: NgbModal, private vivoSyncService: VivoSyncService, private alertService: AlertService,
     private bindComponent: BindComponentService, private modalService: NgbModal) {

  }

  ngOnInit() {
    this.loadView();
  }
  ngOnDestroy() {
    this.reloadInterval.unsubscribe();
  }

  ngAfterViewInit() {
    this.loadControl();

    this.timer = interval(3000);

    this.reloadInterval = this.timer.subscribe(n => {
      if (this.isProcessing) {
        this.loadControl();
      }
    });

    this.bindComponent.subscribe(BindComponentService.LOAD_VIEW_VIVO_SYNC,
      condicao => {
        if (condicao) {
          this.selectedGroup = new DataPackGroup();
          this.loadView();
        }
      }
    );
    this.bindComponent.subscribe(BindComponentService.FILTER_SYNC,
      group => {
        this.groups = new Array<DataPackGroup>();
        this.groups = group;
        this.filtered = true;

      }
    );

  }

  public isSelectLinesAll() {
    return this.checkAll;
  }

  private loadView() {
    this.filtered = false;
    this.hideLinesGroup = false;
    this.hideButton = true;
    this.openModalLoading();
    this.checkAll = false;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.vivoSyncService.loadViewVivoSync(1, SyncListComponent.GROUPS_FETCH_SIZE).subscribe(
      data => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.setGroups(data['groups'], false);
        this.totalGroups = data['totalRecords'];
        this.bindComponent.set(BindComponentService.TOTAL_GROUPS, this.totalGroups);
        if (this.totalGroups > this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = true;
        }

        this.pageGroup = 1;
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = new Array<DataPackGroup>();
      this.groups = groups;
      this.filteredGroups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
    this.clearSelections();

  }

  public isAtivo(condicao: boolean) {
    return (condicao) ? "Ativo" : "Inativo";
  }

  public filterLines(filter?: string) {
    this.clearSelections();
    this.filter = filter || this.filter;
    this.filteredGroups = this.groups.filter(group => {
      let groupFiltered = false;
      group.lines.forEach(line => {
        let lineFiltered = this.filter === SyncListComponent.FILTER_SYNC_LINES;
        if (lineFiltered) {
          lineFiltered = !this.filterValue || this.filterValue === '' || this.searchText(line.userName, this.filterValue) || this.searchText(line.lineNumber, this.filterValue);
        }
        if (!groupFiltered && lineFiltered) {
          groupFiltered = true;
        }
        line.filtered = lineFiltered;
      });
      return groupFiltered;
    });
  }

  public configPermissaoLinhas() {
    let dataPackLine: DataPackLine = new DataPackLine();
    if (this.selectedLineAcount.length === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }

    if (this.selectedLineAcount.length === 1) {
      this.selectedLineAcount.forEach(line => dataPackLine = line);
    }

    const modal = this.modalService.open(ConfigureSyncModalComponent);
    const instance = (<ConfigureSyncModalComponent> modal.componentInstance);
    instance.lineAcountList = this.selectedLineAcount;
    instance.dataPackLine = dataPackLine;

    modal.result.then(result => {
      this.loadView();
      this.loadControl();
    }, reason => null);

  }

  public configPermissaoGrupo(group: DataPackGroup) {
    if (!group || group.lines.length === 0) {
      this.alertService.warn('Grupo não encontrado, ou não possui linhas, tente novamente.');
      return;
    }

    const modal = this.modalService.open(ConfigureSyncModalComponent);
    const instance = (<ConfigureSyncModalComponent> modal.componentInstance);
    instance.lineAcountList = group.lines;
    instance.group = group;
    instance.isGroup = true;

    modal.result.then(result => {
       this.loadView();
      this.loadControl();
    }, reason => null );

  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-content-loading',
      size: 'lg',
    });
  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }
    this.filterLines();
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) !== -1 : false;
  }

  private toggleGroup(group: DataPackGroup, index: number) {
    if (!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.selectedGroup = group;
      this.page = 1;
    } else {

      this.selectedGroup = null;
    }
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.selectedLineAcount = new Array<DataPackLine>();

    this.hideButton = true;
    this.hideLinesGroup = false;
    this.displayShowMoreLinesButton[group.id] = false;

  }

  private sortGroups(field: string) {
    this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
    this.groupSortingCriteria = field;
    this.groups = _.orderBy(this.groups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
  }

  private sortLines(field: string) {
    this.lineSortingAsc = this.lineSortingCriteria == field ? !this.lineSortingAsc : true;
    this.lineSortingCriteria = field;
    this.selectedGroup.lines = _.orderBy(this.selectedGroup.lines, [this.lineSortingCriteria], [this.lineSortingAsc ? 'asc' : 'desc']);
  }

  private clearSelections() {
    this.selectedLineAcount = new Array<DataPackLine>();
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.groupSortingCriteria = null;
    this.groupSortingAsc = true;
  }


  private selectLine(line: DataPackLine) {
    //if (!this.selectedLineAcount.includes(line)) 
    if (!_.some(this.selectedLineAcount, line)) {
      this.selectedLineAcount.push(line);
    } else {
      let index = this.selectedLineAcount.indexOf(line);
      this.selectedLineAcount.splice(index, 1);
    }
  }

  private selectAllLines($event, group: DataPackGroup) {
    let checked = $event.srcElement.checked;
    if (checked) {
      this.selectedGroup = group;
      this.selectedGroup.lines.forEach(line => this.selectedLineAcount.push(line));
      this.checkAll = true;
    } else {
      this.checkAll = false;
      this.selectedLineAcount = new Array<DataPackLine>()
    }
  }

  private showMoreGroups(): void {
    this.openModalLoading();
    this.pageGroup = this.pageGroup + 1;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.vivoSyncService.loadViewVivoSync(this.pageGroup, this.groupsFetchSize).subscribe(
      data => {
        this.setGroups(data['groups'], true);
        if ((this.groupsFetchSize * this.pageGroup) >= this.totalGroups) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines(): void {
    this.openModalLoading();
    this.page = this.page + 1;
    this.vivoSyncService.listLines(this.selectedGroup, this.page, this.linesFetchSize).subscribe(
      data => {

        const value: any = data;

        this.setLines(this.selectedGroup, value, true);
        if (value.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton[this.selectedGroup.id] = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.displayDivLines();
        this.filterLines();
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return '';
    }
    if (msisdn.length == 12) {
      return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }

  private showLines(group: DataPackGroup, index: number) {
    if (!this.filtered) {
      this.openModalLoading();
      this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
      group.lines = new Array<DataPackLine>();
      this.vivoSyncService.loadingLines(group, 1, this.linesFetchSize).subscribe(
        data => {
          const value: any = data;
          this.preencherGroups(index, value);
          this.displayShowMoreLinesButton[group.id] = true;
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          this.displayDivLines();
          this.filterLines();
        },
        err => {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          this.alertService.error(err.result, err);
        }
      );
    } else {
      this.displayShowMoreLinesButton[group.id] = true;
      this.displayDivLines();
      this.filterLines();
    }
  }


  public displayDivLines() {
    this.hideLinesGroup = true;
    this.hideButton = false;
  }
  private hideLines(group: DataPackGroup) {
    this.hideLinesGroup = false;
    this.hideButton = true;
    if (group.id) {
      this.displayShowMoreLinesButton[group.id] = false;
    }

  }

  public loadControl() {
      this.vivoSyncService.loadControlStatus().subscribe(
        data => {
          const value: any = data;
          this.control = value;

          if (this.control.totalProcess === this.control.totalSent) {
            this.loadQueue();
            this.isProcessing = false;
          } else {
            if (this.control.reqId !== undefined) {
              this.isProcessing = true;
            }
          }
        },
        err => {
        }
      );
  }

  public loadQueue() {
      this.vivoSyncService.loadQueueStatus().subscribe(
        data => {
          const value: any = data;
          this.control.queueList = value;
          this.linesWithSuccess = this.control.queueList.filter(queue => queue.errorCode === '0');
          this.linesWithError = this.control.queueList.filter(queue => queue.errorCode !== '0');
        },
        err => {
        }
      );
  }

  public showLineErrors(queueList: Array<DataPackSyncQueue>) {
    const modal = this.modalService.open(ConfigureSyncModalComponent);
    const instance = (<ConfigureSyncModalComponent> modal.componentInstance);
    instance.isShowLineErrors = true;
    instance.queueList = queueList;

    modal.result.then(result => {
    }, reason => null );
  }

  public preencherGroups(index: number, data: DataPackGroup) {
    const group: DataPackGroup = this.groups[index];
    group.id = data.id;
    group.name = data.name;
    group.quota = data.quota;
    group.unallocatedQuota = data.unallocatedQuota;
    group.allocateQuota = data.allocateQuota;
    group.quotaConsume = data.quotaConsume;
    group.bonusConsume = data.bonusConsume;
    group.bonus = data.bonus;
    group.extraDataPackConsume = data.extraDataPackConsume;
    group.extraDataPack = data.extraDataPack;
    group.bisConsume = data.bisConsume;
    group.bis = data.bis;
    group.percentageConsumedBis = data.percentageConsumedBis;
    group.percentageConsumedBonus = data.percentageConsumedBonus;
    group.percentageConsumedExtraDataPack = data.percentageConsumedExtraDataPack;
    group.percentageConsumedQuota = data.percentageConsumedQuota;
    group.isData = data.isData;
    group.groupDefault = data.groupDefault;
    group.manager = data.manager;
    group.lines = data.lines;
    group.totalLines = data.totalLines;
    group.totalOfUnidentifiedLines = data.totalOfUnidentifiedLines;
    group.totalOfRowsWithoutQuota = data.totalOfRowsWithoutQuota;
    group.totalOfRowsOutOfQuota = data.totalOfRowsOutOfQuota;
    group.totalOfRowsOutOflimit = data.totalOfRowsOutOflimit;
    group.totalOfRowsOutOfOverBalancelimit = data.totalOfRowsOutOfOverBalancelimit;
    group.dataNotificationsCount = data.dataNotificationsCount;
    group.voiceNotificationsCount = data.voiceNotificationsCount;
    group.limit = data.limit;
    group.consumedLimit = data.consumedLimit;
    group.availableLimit = data.availableLimit;
    group.overBalanceLimit = data.overBalanceLimit;
    group.consumedOverBalanceLimit = data.consumedOverBalanceLimit;
    group.availableOverBalance = data.availableOverBalance;
    group.percentageConsumedOverBalanceLimit = data.percentageConsumedOverBalanceLimit;
    group.overBalanceLimitNextCycleControll = data.overBalanceLimitNextCycleControll;


  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/vivosync/synclist/content.component.ts